export const parseBooleanEnv = (
  value: string | undefined,
  defaultValue: boolean = true,
): boolean => {
  if (value === undefined) return defaultValue;
  return value.toLowerCase() === "true";
};
